import { render, staticRenderFns } from "./DateMealDanBaoting.vue?vue&type=template&id=8fc27a42&scoped=true&"
import script from "./DateMealDanBaoting.vue?vue&type=script&lang=js&"
export * from "./DateMealDanBaoting.vue?vue&type=script&lang=js&"
import style0 from "./DateMealDanBaoting.vue?vue&type=style&index=0&id=8fc27a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc27a42",
  null
  
)

export default component.exports